/*
 *   Copyright (c) 2020
 *   All rights reserved.
 */
/* PavCon, LLC Proprietary.All rights reserved 2022 */
export const environment = {
  production: false,
  name: 'dev',
  userPoolId: 'us-gov-west-1_Ddypd3rrb', // Your user pool id here
  clientId: '7sml4h9naigjsq50r9ric3s9cr', // Your client id here
  region: 'us-gov-west-1',
  endpoint: 'https://fdre-be-dev.crystalgov.com/',
  snackBarDuration: 9000,
};

/*Distribution Statement B. Distribution authorized to U.S. Government agencies only.PavCon, LLC Proprietary.All rights reserved.
   2020 WARNING: this file may contain export controlled information.*/
